import React, { useEffect, useRef, useState, useContext } from 'react';
import query from 'jquery';
import { Link, NavLink, useNavigate, useSearchParams, useLocation } from 'react-router-dom';

import { SubmitHandler, useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import * as yup from 'yup';
import Swal from 'sweetalert2';

import JWTContext from '../../context/JWTContext';
import axios from '../../utils/axios';
import { useGoogleLogin } from '@react-oauth/google';

const baseSellerUrl = process.env.REACT_APP_SELLER_URL || 'http://localhost:3010/';

const schema = yup
    .object({
        password: yup.string().min(6).required(),
        confirmPassword: yup
            .string()
            .oneOf([yup.ref('password'), null], 'Passwords must match')
            .required()
    })
    .required();

const ResetPassword = () => {
    const navigate = useNavigate();
    const [isShowPassword, setIsShowPassword] = React.useState(false);
    const location = useLocation();

    const params = new URLSearchParams(location.search);
    const token = params.get('token');
    const user = params.get('username');
    const redirectPath = params.get('redirect') || '/';

    const { resetPassword } = useContext(JWTContext);

    const [showPassword, setShowPassword] = useState(false);
    const [showConfirmPassword, setShowConfirmPassword] = useState(false);

    const inputClass = (field) => `form-control border-0 border-bottom p-10 text-14 ${errors[field] ? 'is-invalid' : ''}`;

    const {
        register,
        handleSubmit,
        formState: { errors },
        setError
    } = useForm({
        resolver: yupResolver(schema)
    });

    const onSubmit = async (data) => {
        if (data.password !== data.confirmPassword) {
            setError('confirmPassword', { type: 'manual', message: 'Passwords do not match' });
            return;
        }
        if (!token && !user) {
            setError('confirmPassword', { type: 'manual', message: 'Invalid reset link' });
            return;
        }
        try {
            const result = await resetPassword(
                token, 
                user,
                data.password,
                data.confirmPassword
            );

            Swal.fire({
                title: 'Success',
                text: 'Password reset successfully. Please login with your new password.',
                icon: 'success'
            }).then(() => {
                navigate('/admin/login');
            });

        } catch (err) {
            //console.log(err);
            Swal.fire({
                title: 'Error',
                text: err,
                icon: 'error'
            });
        }
    };

    return (
        <>
            <section
                className="banner-form text_inter position-relative"
                style={{ backgroundImage: "url('/assets/images/profile_temp/bgheader.jpg')", height: '100vh' }}
            >
                <div className="bgHalf"></div>
                <div className="container h-100 z-3 position-relative">
                    <div className="row align-items-center justify-content-center h-100">
                        <div className="col-12 col-md-6 formstyle">
                            <span className="fw-bold text-36 text-white text-center d-block mx-auto text_quicksand">Change Password</span>
                            <div className="p-20 px-0 ps-md-32 pe-md-0">
                                <div className="bg-white p-20 text_quicksand  mx-auto" style={{ borderRadius: '6px', maxWidth: '480px' }}>
                                    <div className="mt-20">
                                        <span className="text-14 text-center lh_24">
                                            {' '}
                                            Please enter your new password below. Make sure to choose a strong password that you haven't
                                            used before.{' '}
                                        </span>
                                    </div>
                                    <form onSubmit={handleSubmit(onSubmit)}>
                                        <div className="form-group mb-24 password-switchable position-relative">
                                            {/* <input type="password" className="form-control border-0 border-bottom p-10  text-14" placeholder="Enter Password" {...register("password")}  /> */}
                                            <input
                                                type={showPassword ? 'text' : 'password'}
                                                className={inputClass('password')}
                                                placeholder="Enter Password"
                                                {...register('password')}
                                            />
                                            <div className="position-absolute top-0 end-0">
                                                <button type="button" className="btn" onClick={() => setShowPassword((prev) => !prev)}>
                                                    {showPassword ? (
                                                        <i className="ph-bold ph-eye-closed  text-black"></i>
                                                    ) : (
                                                        <i className="ph-bold ph-eye  text-black"></i>
                                                    )}
                                                </button>
                                                {/* <button type="button" className="btn open"><span className="text-black"><i className="ph-bold ph-eye"></i></span></button>
                                                    <button type="button" className="btn close d-none"><span className="text-black"><i className="ph-bold ph-eye-closed"></i></span></button> */}
                                            </div>
                                            {errors.password && <small className="text-danger">{errors.password.message}</small>}
                                        </div>{' '}

                                         <div className="form-group mb-24 password-switchable position-relative">
                                            {/* <input type="password" className="form-control border-0 border-bottom p-10  text-14" placeholder="Enter Password" {...register("password")}  /> */}
                                            <input
                                                type={showConfirmPassword ? 'text' : 'password'}
                                                className={inputClass('password')}
                                                placeholder="Enter Confirm Password"
                                                {...register('confirmPassword')}
                                            />
                                            <div className="position-absolute top-0 end-0">
                                                <button type="button" className="btn" onClick={() => setShowConfirmPassword((prev) => !prev)}>
                                                    {showConfirmPassword ? (
                                                        <i className="ph-bold ph-eye-closed  text-black"></i>
                                                    ) : (
                                                        <i className="ph-bold ph-eye  text-black"></i>
                                                    )}
                                                </button>
                                                {/* <button type="button" className="btn open"><span className="text-black"><i className="ph-bold ph-eye"></i></span></button>
                                                    <button type="button" className="btn close d-none"><span className="text-black"><i className="ph-bold ph-eye-closed"></i></span></button> */}
                                            </div>
                                            {errors.confirmPassword && <small className="text-danger">{errors.confirmPassword.message}</small>}
                                        </div>{' '}
                                        <button className="btn btn_register font-14 fw-bold text_quicksand" type="submit">
                                            Save Password
                                        </button>
                                    </form>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </>
    );
};

export default ResetPassword;
